module.exports = __webpack_public_path__ + "static/img/finance-type-car.ee6517a6.svg";